type NamedOption = { id: string | number; name: string };

export function isNamedOptionsArray(value: unknown): value is NamedOption[] {
	return (
		Array.isArray(value) &&
		typeof value[0] === "object" &&
		value[0] !== null &&
		"id" in value[0] &&
		"name" in value[0]
	);
}
